export interface ILines {
    [key: string]: string
}

export interface ILine {
    activeName: string,
    lines: ILines
}

export interface ILineAction {
    type: string,
    payload?: {
        activeName?: string,
        lines?: ILines
    }
}

const lineDefault: ILine = {
    activeName: "",
    lines: {}
}

function lineReducer(state: ILine = lineDefault, action: ILineAction): ILine {

    switch (action.type) {
        case "PROGRESS_LINE_UPDATE":
            return Object.assign({}, state, action.payload);
        case "SIGN_OUT":
            return {
                activeName: "",
                lines: {}
            };
        case "UPDATE_PROJECT":
            return {
                activeName: "",
                lines: {}
            };
        case "CLEAR_PROGRESS":
            return {
                activeName: "",
                lines: {}
            };
        case "PROGRESS_CLEAR":
            return lineDefault;
        default:
            return state;
    }
}

export default lineReducer;